import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import config from '../config';
import { curry } from '../utils/func';
export default curry(function (defaultDelay, Origin) {
  var _temp;

  return _temp =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(_temp, _PureComponent);

    var _super = _createSuper2(_temp);

    function _temp(props) {
      var _this;

      _classCallCheck(this, _temp);

      _this = _super.call(this, props);
      _this.changeLocked = void 0;
      _this.changeTimer = void 0;
      _this.state = {
        value: props.value
      };
      _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
      _this.forceChange = _this.forceChange.bind(_assertThisInitialized(_this));
      _this.cancelChange = _this.cancelChange.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_temp, [{
      key: "getValue",
      value: function getValue() {
        if (this.changeLocked) return this.state.value;
        return this.props.value;
      }
    }, {
      key: "getDelay",
      value: function getDelay() {
        var delay = this.props.delay;
        if (delay !== undefined) return delay;
        if (config.delay !== undefined) return config.delay;
        return defaultDelay;
      }
    }, {
      key: "handleChange",
      value: function handleChange(value) {
        var _this2 = this;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var delay = this.getDelay();

        if (delay === 0) {
          var _this$props;

          (_this$props = this.props).onChange.apply(_this$props, [value].concat(args));

          return;
        }

        this.setState({
          value: value
        });
        this.changeLocked = true;
        this.forceUpdate();
        if (this.changeTimer) clearTimeout(this.changeTimer);
        this.changeTimer = setTimeout(function () {
          var _this2$props;

          _this2.changeLocked = false;

          (_this2$props = _this2.props).onChange.apply(_this2$props, [value].concat(args));
        }, delay);
      }
    }, {
      key: "cancelChange",
      value: function cancelChange() {
        if (this.changeTimer) clearTimeout(this.changeTimer);
      }
    }, {
      key: "forceChange",
      value: function forceChange(value) {
        var _this$props2;

        this.cancelChange();
        this.setState({
          value: value
        });

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        (_this$props2 = this.props).onChange.apply(_this$props2, [value].concat(args));

        this.changeLocked = false;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            value = _this$props3.value,
            onChange = _this$props3.onChange,
            props = _objectWithoutProperties(_this$props3, ["value", "onChange"]);

        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            value: this.getValue(),
            onChange: this.handleChange,
            forceChange: this.forceChange,
            cancelChange: this.cancelChange
          }))
        );
      }
    }]);

    return _temp;
  }(PureComponent), _temp;
});